export default async function useGetSeoUrl(categoryIds: string | string[]) {
    const config = useRuntimeConfig();
    const categoryIdsArray = Array.isArray(categoryIds) ? categoryIds : categoryIds.split(',');

    try {
        const result = await $fetch(config.public.shopwareEndpoint + 'category', {
            method: 'POST',
            body: {
                ids: categoryIdsArray,
                associations: {
                    seoUrls: {},
                },
            },
            headers: {
                'Content-Type': 'application/json',
                'sw-access-key': config.public.shopwareToken,
            },
        });

        if (result && result.elements) {
            return result.elements;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching categories:', error);
        return null;
    }
}
